import { useEffect } from 'react'
import { useBrand } from '../contexts/BrandContext'

interface DocumentMeta {
  title: string
  description: string
  image?: string
  siteName?: string
}

function setMeta(selector: string, attribute: 'name' | 'property', key: string, content: string) {
  let tag = document.head.querySelector<HTMLMetaElement>(selector)

  if (!tag) {
    tag = document.createElement('meta')
    tag.setAttribute(attribute, key)
    document.head.appendChild(tag)
  }

  tag.setAttribute('content', content)
}

export function useDocumentMeta({ title, description, image, siteName }: DocumentMeta) {
  const { brand } = useBrand()
  const resolvedImage = image ?? brand.images.share
  const resolvedSiteName = siteName ?? brand.name

  useEffect(() => {
    document.title = title

    setMeta('meta[name="description"]', 'name', 'description', description)
    setMeta('meta[property="og:site_name"]', 'property', 'og:site_name', resolvedSiteName)
    setMeta('meta[property="og:type"]', 'property', 'og:type', 'website')
    setMeta('meta[property="og:title"]', 'property', 'og:title', title)
    setMeta('meta[property="og:description"]', 'property', 'og:description', description)
    setMeta('meta[property="og:image"]', 'property', 'og:image', resolvedImage)
    setMeta('meta[property="og:url"]', 'property', 'og:url', window.location.href)
    setMeta('meta[name="twitter:card"]', 'name', 'twitter:card', 'summary_large_image')
    setMeta('meta[name="twitter:title"]', 'name', 'twitter:title', title)
    setMeta('meta[name="twitter:description"]', 'name', 'twitter:description', description)
    setMeta('meta[name="twitter:image"]', 'name', 'twitter:image', resolvedImage)
  }, [title, description, resolvedImage, resolvedSiteName])
}
